var registry = {
  dashboard: {},
  page: {},
  wizard: {}
};

function normalizeType(value) {
  var t = (value || "").toString().trim().toLowerCase();
  if (!(t)) return "";
  if (!(registry[t])) return "";
  return t;
}

function normalizeNamespace(value) {
  return (value || "").toString().trim().toLowerCase();
}

function register(type, namespace, handler) {
  var t = normalizeType(type);
  var ns = normalizeNamespace(namespace);
  if (!(t) || !(ns) || typeof handler !== "function") return false;

  if (!(registry[t][ns])) registry[t][ns] = [];
  registry[t][ns].push(handler);
  return true;
}

async function run(type, namespace, context) {
  var t = normalizeType(type);
  var ns = normalizeNamespace(namespace);
  if (!(t) || !(ns)) return { success: true, ran: 0 };

  var handlers = [];
  if (registry[t]["*"]) handlers = handlers.concat(registry[t]["*"]);
  if (registry[t][ns]) handlers = handlers.concat(registry[t][ns]);

  var ran = 0;
  for (var i = 0; i < handlers.length; i++) {
    await handlers[i](context || {});
    ran += 1;
  }

  return {
    success: true,
    ran: ran
  };
}

async function runFromElement(element, extraContext) {
  if (!(element)) return { success: true, ran: 0 };

  var type = element.getAttribute("data-ua-init-type") || "";
  var namespace = element.getAttribute("data-ua-init-namespace") || "";
  var context = {
    element: element,
    type: normalizeType(type),
    namespace: normalizeNamespace(namespace)
  };

  if (extraContext && typeof extraContext === "object") {
    for (var key in extraContext) {
      if (Object.prototype.hasOwnProperty.call(extraContext, key)) {
        context[key] = extraContext[key];
      }
    }
  }

  var contextId = element.getAttribute("data-ua-init-context-id") || "";
  if (contextId) {
    var contextNode = document.getElementById(contextId);
    if (contextNode) {
      try {
        var parsed = JSON.parse(contextNode.textContent || "{}");
        context.context = parsed;
      } catch (error) {
        console.error("Invalid init context payload.", error);
      }
    }
  }

  return await run(context.type, context.namespace, context);
}

async function autoRun() {
  var elements = document.querySelectorAll("[data-ua-init-type][data-ua-init-namespace]");
  for (var i = 0; i < elements.length; i++) {
    await runFromElement(elements[i]);
  }
}

module.exports = {
  register: register,
  run: run,
  runFromElement: runFromElement,
  autoRun: autoRun
};
